(() => {
  const sizes=new Map(), origin='https://droplit-nfc.brian-1b8.workers.dev';
  const factor=value=>({small:.85,medium:1,large:1.15,xl:1.3225,xxl:1.520875,xxxl:1.74900625})[value]||1;
  function update(root){
    if(document.querySelector('[data-mike-page]'))return;
    const drop=root.__dlSlots?.[root.__dlGetActive?.()||0], box=root.querySelector('.stage .drop');
    if(!box)return;
    const id=drop?.libraryDesignId||drop?.mikeDesignId;
    const value=sizes.get(id)||sizes.get(drop?.production)||sizes.get(drop?.originalPreview)||sizes.get(drop?.preview);
    const scale=String(factor(value));if(box.style.scale!==scale)box.style.scale=scale;
  }
  async function init(){
    const roots=[...document.querySelectorAll('.dl')];if(!roots.length)return;
    roots.forEach(root=>{
      root.addEventListener('click',()=>requestAnimationFrame(()=>update(root)));
      const image=root.querySelector('[data-preview]');if(image)new MutationObserver(()=>update(root)).observe(image,{attributes:true,attributeFilter:['src','hidden']});
    });
    window.addEventListener('droplit:image-selected',e=>{if(e.detail?.root)update(e.detail.root);});
    try{
      let after='';const seen=new Set();
      do{
        const url=new URL('/api/library/catalog',origin);if(after)url.searchParams.set('after',after);
        const response=await fetch(url,{signal:AbortSignal.timeout(15000)});if(!response.ok)break;
        const data=await response.json();for(const d of data.designs||[])for(const key of [d.id,d.artwork_url,d.preview_url])if(key)sizes.set(key,d.preview_size||'medium');
        roots.forEach(update);after=data.next||'';if(seen.has(after))break;seen.add(after);
      }while(after);
    }catch{}
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();
